import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  Wrapper,
  Icon,
  Content,
  ExternalKey,
  TopicName,
  Info,
  Collapse } from './styled';
import SvgIcon from '../../svg-icon/svg-icon';
import { ExpandButton, StandardDropdown } from '../../../helpers/icon-dictionary';
import ContextModal, { ContextModalWidth } from '../../context-modal';
import StandardInfo from '../../standard-info';
import { getContextCoords } from '../../../helpers/utils';
import {
  displayModalInfo,
  hideStandard
} from '../../../containers/upf-assign/upf-assign-actions';
import OutsideClickHandler from '../../../helpers/hoc/close/outside-click-handler';


const StandardCollapsed = ({ handleOnExpand, externalKey, topicName, description, learningJourney, id, i18n }) => {
  const dispatch = useDispatch();
  const myRef = useRef(null);

  const [showInfo, setInfo] = useState(false);
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);
  const [positionArrow, setPositionArrow] = useState(0);
  const [positionXCallout, setPositionXCallout] = useState(0);
  const [positionYCallout, setPositionYCallout] = useState(0);
  const [positionArrowCallout, setPositionArrowCallout] = useState(0);
  const [callOut, setCallOut] = useState(false);
  const standardRef = useRef(null);
  const [contextTheme, setContextTheme] = useState(null);

  const showDropdown = () => {
    const { posX, posY, posArrow } = getContextCoords(myRef.current.getBoundingClientRect(), ContextModalWidth);
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setCallOut(false);

    if (showInfo) {
      setInfo(false);
    } else {
      setInfo(true);
    }
  };

  const hideStandardBlock = () => {
    dispatch(hideStandard(id));
    dispatch(displayModalInfo(-1));
  };

  const showCallOut = () => {
    const { posX, posY, posArrow } =
    getContextCoords(standardRef.current.getBoundingClientRect(), ContextModalWidth);
    setPositionYCallout(posY);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOut(true);
  };

  const hideCallOut = () => {
    setCallOut(false);
  };

  return (
    <Wrapper>
      <Collapse role="button" tabIndex="0" onClick={() => handleOnExpand(false)}>
        <SvgIcon icon={ExpandButton} />
      </Collapse>
      <Info
        role="button"
        onClick={showDropdown}
        lj={learningJourney.length}
        ref={standardRef}
        onMouseEnter={showCallOut}
        onMouseLeave={hideCallOut}>
        <Content>
          <ExternalKey>{externalKey}</ExternalKey>
          <TopicName>{topicName}</TopicName>
        </Content>
        <Icon ref={myRef}>
          <SvgIcon icon={StandardDropdown} />
        </Icon>
      </Info>
      <OutsideClickHandler callback={() => setInfo(false)} forButton={`showContextModal_${id}`}>
        <ContextModal
          show={showInfo}
          positionArrow={positionArrow}
          positionX={positionX}
          positionY={positionY}>
          <StandardInfo
            standardName={topicName}
            externalKey={externalKey}
            description={description}
            hideStrand={hideStandardBlock}
            displayHideOption
            i18n={i18n} />
        </ContextModal>
        <ContextModal
          show={callOut}
          positionArrow={positionArrowCallout}
          positionX={positionXCallout}
          positionY={positionYCallout}
          contextTheme={contextTheme}
          name={topicName} />
      </OutsideClickHandler>
    </Wrapper>
  );
};

StandardCollapsed.propTypes = {
  handleOnExpand: PropTypes.func.isRequired,
  externalKey: PropTypes.string,
  topicName: PropTypes.string,
  description: PropTypes.string,
  learningJourney: PropTypes.array.isRequired,
  id: PropTypes.number,
  i18n: PropTypes.object
};

StandardCollapsed.defaultProps = {
  handleOnExpand: () => {},
  externalKey: '',
  topicName: '',
  description: ''
};

export default StandardCollapsed;
